import { render, staticRenderFns } from "./rate-value-adds.vue?vue&type=template&id=321f959d&scoped=true&"
import script from "./rate-value-adds.vue?vue&type=script&lang=js&"
export * from "./rate-value-adds.vue?vue&type=script&lang=js&"
import style0 from "./rate-value-adds.vue?vue&type=style&index=0&id=321f959d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321f959d",
  null
  
)

export default component.exports